// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var DashboardFeatureStatsController = function ($scope, DashboardFeatureStats, DashboardPSPStats) {

    let init = function () {

        $scope.featureCounts = null;

        DashboardFeatureStats.query({}, function (data) {
            $scope.featureCounts = data;
        });

        $scope.pspCounts = null;

        DashboardPSPStats.query({}, function (data) {
            $scope.pspCounts = data;
        })

    };

    $scope.$on('refresh', function () {
        init();
    });

    init();
};

DashboardFeatureStatsController.$inject = ['$scope', 'DashboardFeatureStats', 'DashboardPSPStats'];
